import { Button, Modal } from 'antd';

import { formatPackLabel } from '../_utils/formatPackList';

import styles from './ValidationExperienceManualEditModal.module.scss';

type Props = {
  isOpened: boolean;
  experienceNames: string[];
  packNames: string[];
  isLoading?: boolean;
  handleCancel: () => void;
  handleSaveChange: () => void;
};

export const ValidationExperienceManualEditModal = ({
  isOpened,
  experienceNames,
  packNames,
  isLoading,
  handleCancel,
  handleSaveChange,
}: Props) => {
  const isSinglePack = packNames.length === 1;

  return (
    <Modal
      className={styles.modal}
      wrapClassName={styles.validationManualEditModal}
      open={isOpened}
      title="Apply your changes?"
      onCancel={handleCancel}
      footer={[
        <Button size="large" key="back" type="ghost" onClick={handleCancel}>
          Back to edit
        </Button>,
        <Button
          key="save"
          size="large"
          type="primary"
          onClick={handleSaveChange}
          loading={isLoading}
        >
          Confirm changes
        </Button>,
      ]}
    >
      <p>By saving your changes:</p>
      {experienceNames.map((name, index) => (
        <p key={`${name}-${index}`}>
          {name} will be unavailable on selected days.
        </p>
      ))}
      <p>
        This activity is a must-have in some of your packages. As a result, the
        following {isSinglePack ? 'package' : 'packages'} may be removed from
        sale on certain dates:
      </p>
      <ul>
        {packNames.map((name, index) => (
          <li key={`${name}-${index}`}>
            <b>{formatPackLabel(name)}</b>
          </li>
        ))}
      </ul>
    </Modal>
  );
};
